module.exports = __webpack_public_path__ + "static/media/close_24px.22f657c0.svg";